import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import FadeInSection from "../../animations/FadeInSection";
import ProductHomeCard from "./ProductCard";
import type { ProductHomeType } from "@/types/home-type";

export default function ProductPreviewSection({
    product,
}: {
    product: ProductHomeType[];
}) {
    const { t } = useTranslation();
    const { lang } = useParams();

    if (!product || product.length === 0) return null;

    return (
        <FadeInSection>
            <section
                id="produk"
                className="relative dark:bg-dark px-0 transition-colors duration-300">
                <div className="max-w-8xl mx-auto relative z-20">
                    <div className="mb-6 flex items-center justify-between">
                        <div className="text-left">
                            <div className="flex items-center justify-left gap-3 text-xs md:text-sm font-semibold tracking-[0.15em] uppercase text-gold dark:text-gold mb-1">
                                {t("home.product.badge")}
                                <div className="w-12 h-px bg-gold/30 dark:bg-gold/30" />
                            </div>
                            <h2 className="text-xl sm:text-2xl md:text-4xl font-serif font-bold text-dark dark:text-white leading-tight transition-colors duration-300">
                                {t("home.product.title_1")}{" "}
                                <em className="italic text-gold dark:text-gold pr-1">
                                    {t("home.product.title_span")}
                                </em>{" "}
                                {t("home.product.title_2")}
                            </h2>
                        </div>
                        <Link
                            to={`/${lang}/shop`}
                            aria-label={t("home.product.see_all")}
                            className="inline-flex items-center text-sm gap-2 text-gold dark:text-white/60 hover:text-gold dark:hover:text-gold-light font-semibold tracking-wide border border-gold/30 dark:border-gold/20 hover:border-gold dark:hover:border-gold px-4 py-2 rounded-full transition-all duration-300 hover:shadow-md bg-surface dark:bg-dark/50">
                            <span className="hidden md:flex">
                                {t("home.product.see_all")}
                            </span>{" "}
                            <ArrowRight size={18} />
                        </Link>
                    </div>

                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8 mb-12">
                        {product.map((prod, i) => (
                            <ProductHomeCard
                                key={`home-product-${i}`}
                                product={prod}
                            />
                        ))}
                    </div>
                </div>
            </section>
        </FadeInSection>
    );
}
